import { render } from "./z-money.vue?vue&type=template&id=cdfaaa6e"
import script from "./z-money.vue?vue&type=script&lang=js"
export * from "./z-money.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__